/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-09-05 17:40:03
 * @LastEditors: liuziwei
 * @Description: 订单详情页 - 券卡片
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view wx:if="{{isShowCardFrame}}" class="coupon-card-container">
    <card-frame class="{{cardFrameClass}}" cardConf="{{couponCardConf}}">
      <coupon-item class="coupon-item" couponData="{{couponData}}" />
    </card-frame>
  </view>
</template>

<script>
  import store from '@/store'
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    computed: {
      ...store.mapState({
        couponInfo: 'order.coupon_info',
        statusName: 'order.base_info.status_name', // 订单准确状态（中文）
      }),
      // 卡片 title 文案
      couponDesc() {
        const issuedDesc = this.couponInfo?.make_order_coupon_desc
        const issuingDesc = this.couponInfo?.order_pay_suc_coupon_desc
        // this.state 为原订单状态, 在改签 - 非预付（改签中）场景下, 不准确
        return this.statusName === '已出票' ? issuedDesc : issuingDesc
      },
      // 是否展示卡片
      isShowCardFrame() {
        return !!this.couponDesc
      },
      // 卡片配置
      couponCardConf() {
        return {
          title: {
            icon: 'https://ut-static.udache.com/webx/sfc/8LWLwsBdPKWUbAVzKwETK.png',
            text: this.couponDesc || '',
            color: '#333',
            fontSize: '14px'
          }
        }
      },
      // 优惠券信息
      couponData() {
        return this.couponInfo?.backward_coupon_info ?? {}
      },
      // 卡片样式
      cardFrameClass() {
        return Object.keys(this.couponData)?.length ? '' : 'card-title'
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-card-container
    background #fff
    border-radius 8px
    margin 10px auto
    .card-title
      border-radius 8px
      background #FFF6F1
      box-sizing border-box
      border 1.5px solid #fff
    .coupon-item
      margin-top 12px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'card-frame': '@/components/card-frame',
      'coupon-item': './coupon-item'
    }
  }
</script>
